module.exports = __webpack_public_path__ + "static/media/DSC00176.258de162.jpg";